export default __webpack_public_path__ + "static/media/2_Jordi Estalella_179x177.c81e8ae8.webp";